import type { MapData } from "./model";

/** Fetches the published map data (locations + category styles) from the live API. */
export async function fetchMapData(): Promise<MapData> {
  const res = await fetch("/api/map-data", { credentials: "omit" });
  if (!res.ok) throw new Error(`map-data yüklenemedi: ${res.status}`);
  return (await res.json()) as MapData;
}
